import { IEnvironmentVariables } from '@env/IEnvironment';

export const environment: IEnvironmentVariables = {
  production: false,
  buildNumber: '_BUILDNUMBER_',
  hmr: true,
  baseUrl: 'https://mnc-dev-web-portal.azurewebsites.net/',
  themeId: 1,
  stage: 'develop',
  version: '_VERSION_',
  appInsights: 'e7312de9-8ac4-4671-8296-db39181d8a16',
  appInsightsAppId: '55988c1a-fc4e-40cc-b51e-20c317d29615',
  appInsightsApiKey: 'rj61pmch3vkyfcfuuqtf2x2oratdotn8hwjn7fpl',
  routes: {
    feeds: 'feeds',
    error404: '404'
  },
  apiUrl: 'https://api-homehealth.portaldev.mynexuscare.com',
  apiCallRetryCount: 0,
  logLimit: 30,
  snackBarDuration: 3000,
  signalRConfig: {
    active: true,
    hubUrl: 'https://mnc-signalr-api.azurewebsites.net/',
    canSendMessage: false
  },
  fromEmail: 'mynexusportal@mynexuscare.com',
  bodyEmail: `Thank you for registering with Carelon. You will be contacted once your account is active.<br/><br/>
    Please note that in order to add additional security measures, you will also be automatically enrolled in multi-factor 
    authentication and will need to enter a one-time verification code to sign in after completing the account set-up. 
    You can receive the code either at the email address that you used during registration, or on your device after you enroll it via an authenticator app, such as Microsoft Authenticator.<br/><br/>
    If you have any questions, please contact Carelon Portal Support at 1-844-411-9622.<br/><br/>
    Thank you,<br/>
    Carelon Medical Benefits Management Portal team<br/>
    Customer Support: 1-844-411-9622.<br/>`,
  loginHomePage: 'https://mnc-dev-web-portal.azurewebsites.net/',
  recaptchaSiteKey: '6Lci5akUAAAAAAmC4DagPkQ7Vz4hCjix7mK8TaXW'
};
